import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppOnlineStateService } from "./app-online-state.service";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { UserHelperService } from "@main/users/user-helper.service";
import { CoreRole } from "@main/roles";
import { Subscription } from "rxjs";
import { PlayerOfflineStorage } from "@project/player/player-offline.storage";

@Component({
    selector: "app-offline-indicator",
    templateUrl: "./app-offline-indicator.component.html",
    styleUrls: ["./app-offline-indicator.component.scss"]
})
export class AppOfflineIndicatorComponent implements OnInit, OnDestroy {
    isOffline = false;
    private onlineChangeSuscription: Subscription;

    constructor(
        private appOnlineStateService: AppOnlineStateService,
        private broadcastService: BroadcastService,
        private userHelperService: UserHelperService
    ) {}

    ngOnInit() {
        this.isOffline = !this.appOnlineStateService.isAppOnline;

        this.onlineChangeSuscription = this.broadcastService
            .on<{ isAppOnline: boolean }>(AppOnlineStateService.AppOnlineStateChanged)
            .subscribe(data => (this.isOffline = !data.isAppOnline));
    }

    ngOnDestroy(): void {
        this.onlineChangeSuscription?.unsubscribe();
    }

    get isGenericPatientLogin(): boolean {
        return this.userHelperService.hasRole(CoreRole.GenericPatientLogin);
    }

    get selfRegisterPatientsCount(): number {
        return PlayerOfflineStorage.getAll().filter(x => x.selfRegister).length;
    }

    get selfRegisterPatientCountMessage(): string {
        return `${this.selfRegisterPatientsCount} Self-Registered Patients created OFFLINE, awaiting upload…`;
    }
}
